<template>
  <chart-card
    title="Canal recebido"
    :subtitle="cardDescription"
    :data="channelData"
    :controls="false"
    loader=""
    :chart-loading="loading"
    :chartHeight="220"
    card-height="300"
    emptyChartPaddingTop="0px"
    is-integer
  />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { mariaResults } from '@/modules/maria/campanha-da-maria-v2/mixins/maria-results'

export default {
  name: 'ReceiveChannelChart',

  components: {
    ChartCard,
  },

  mixins: [mariaResults],

  props: {
    dataChart: {
      type: Object,
      required: true,
    },
    chosenCustomerType: {
      type: String,
      required: true,
    },
  },

  computed: {
    cardDescription() {
      let clientType = ''
      if (this.chosenCustomerType === 'received_and_bought') clientType = 'qualquer produto'
      if (this.chosenCustomerType === 'received_and_bought_with_offer_products') clientType = 'produtos da oferta'
      if (this.chosenCustomerType === 'received_and_bought_with_received_product') clientType = 'produto que recebeu via variável na mensagem'
      return `Disparos recebidos por clientes, que compraram ${clientType} nesta campanha, agrupados por canal.`
    },
    channelData() {
      return {
        datasets: [
          {
            backgroundColor: [
              ...(!this.isChannelActivated('push') ? [] : ['#801DE3']),
              ...(!this.isChannelActivated('sms') ? [] : ['#F36600']),
              ...(!this.isChannelActivated('email') ? [] : ['#0063C6']),
              ...(!this.isChannelActivated('whatsapp') ? [] : ['#0DA740']),
            ],
            borderColor: [
              ...(!this.isChannelActivated('push') ? [] : ['#801DE3']),
              ...(!this.isChannelActivated('sms') ? [] : ['#F36600']),
              ...(!this.isChannelActivated('email') ? [] : ['#0063C6']),
              ...(!this.isChannelActivated('whatsapp') ? [] : ['#0DA740']),
            ],
            data: [
              ...(!this.isChannelActivated('push') ? [] : [this.dataChart?.channels.push[this.chosenCustomerType].messages]),
              ...(!this.isChannelActivated('sms') ? [] : [this.dataChart?.channels.sms[this.chosenCustomerType].messages]),
              ...(!this.isChannelActivated('email') ? [] : [this.dataChart?.channels?.email[this.chosenCustomerType].messages]),
              ...(!this.isChannelActivated('whatsapp') ? [] : [this.dataChart?.channels.whatsapp[this.chosenCustomerType].messages]),
            ],
            fill: false,
            label: 'Cupons',
            strokeColor: [
              ...(!this.isChannelActivated('push') ? [] : ['#801DE3']),
              ...(!this.isChannelActivated('sms') ? [] : ['#F36600']),
              ...(!this.isChannelActivated('email') ? [] : ['#0063C6']),
              ...(!this.isChannelActivated('whatsapp') ? [] : ['#0DA740']),
            ],
          },
        ],
        labels: [
          ...(!this.isChannelActivated('push') ? [] : ['Push Aplicativo']),
          ...(!this.isChannelActivated('sms') ? [] : ['SMS']),
          ...(!this.isChannelActivated('email') ? [] : ['E-mail']),
          ...(!this.isChannelActivated('whatsapp') ? [] : ['Whatsapp']),
        ],
      }
    },
  },
}
</script>

<style></style>
